import { render, staticRenderFns } from "./currency-calculator.vue?vue&type=template&id=975b99c6"
import script from "./currency-calculator.vue?vue&type=script&lang=js"
export * from "./currency-calculator.vue?vue&type=script&lang=js"
import style0 from "./currency-calculator.vue?vue&type=style&index=0&id=975b99c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports